export default (animationInterval) => {
	document.querySelectorAll('[data-video-st="btn"]').forEach((button) => {
		button.addEventListener('click', function () {
			const video = button.closest('[data-video-st="container"]').querySelector('video');
			const container = button.closest('[data-video-st="container"]');
			const secondContainer = button.closest('[data-video-st="secondContainer"]');
			const imgOne = secondContainer?.querySelector('[data-video-st="imgOne"]');
			const imgTwo = secondContainer?.querySelector('[data-video-st="imgTwo"]');

			if (video.paused) {
				video.play();
				video.muted = false;
				container.classList.add('is-play');
				secondContainer?.classList.add('is-play');
			} else {
				video.pause();
				video.muted = true;
				container.classList.remove('is-play');
				secondContainer?.classList.remove('is-play');
			}
		});
	});
};
